import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { MediaItem } from '../models';
import { PaginationParams } from '../types';

export const mediasActions = createActionGroup({
    source: 'Medias',
    events: {
        'Get Media': props<{ value: PaginationParams }>(),
        'Get Media Success': props<{ payload: MediaItem[]; total: number }>(),
        'Get Media Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
